import {
  SectorBridgeActPreview,
  SectorBridgeBridgeActs,
  SectorBridgeSectors,
} from '@gasbi/shared/web/Gds';
import { RouteObject } from 'react-router-dom';

import { Pages } from '@/pages';

export const gdsSectorBridgeDetailsRoutes: RouteObject[] = [
  {
    element: <SectorBridgeSectors />,
    index: true,
  },
  {
    path: Pages.BRIDGE_ACTS,
    element: <SectorBridgeBridgeActs />,
    children: [{ path: ':bridgeActId', element: <SectorBridgeActPreview /> }],
  },
];
